import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import {
  ShiftManagementShiftConfigurationFragment,
  ShiftManagementTemplateWeekFragment,
} from 'generated/resources/graphql'

import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { useShiftTimeFormatted } from 'modules/shift_management/hooks/useShiftTimeFormatted'
import { getColor } from 'modules/shift_management/lib/getColor'

interface Props {
  templateWeek: ShiftManagementTemplateWeekFragment
  shiftConfig: ShiftManagementShiftConfigurationFragment
}

const ShiftCell = ({ templateWeek, shiftConfig }: Props) => {
  const showColor = hasFeature('shift_management_colours_for_shifts')
  const formatShiftTime = useShiftTimeFormatted()

  const color = templateWeek.color
  const background = getColor(color)

  const { startAt, endAt, formattedEndAt, formattedStartAt } = shiftConfig
  const isShiftOvernight = startAt >= endAt

  if (!formattedEndAt || !formattedStartAt) return

  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      {showColor ? (
        <Box
          flexDirection="row"
          overflowX="hidden"
          paddingX="s8"
          paddingY="s2"
          background={background}
          borderRadius={{ all: 'abs008' }}
        >
          <Text.Normal size="200" weight="medium" ellipsis color="grey1000">
            {formatShiftTime(formattedStartAt, formattedEndAt)}
          </Text.Normal>
        </Box>
      ) : (
        <Tag type={Tag.Types.grey}>{formatShiftTime(formattedStartAt, formattedEndAt)}</Tag>
      )}
      {isShiftOvernight && (
        <Tag type={Tag.Types.grey}>{i18n.t('shift_management.plus_1_day_tag')}</Tag>
      )}
    </Box>
  )
}

export default ShiftCell
